<template>
  <nav class="navbar top-nav sticky-top border-bottom bg-white">
    <div class="container-fluid">
      <div class="row w-100">
        <div class="col-3 d-flex">
          <button
            type="button"
            class="text-muted btn p-0 border-0 bg-transparent"
            @click="goBack"
            @mouseover="showTooltip"
            @mouseleave="hideTooltip"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="$t('Back')"
            :disabled="backLoading"
          >
            <i v-if="!backLoading" class="fas fa-chevron-circle-left"></i>
            <i v-else class="fas fa-spinner fa-spin"></i>
          </button>
          <a
            @click.prevent="setSideBarLeft('lectureList')"
            href="#"
            class="text-muted ms-auto d-none"
            @mouseover="showTooltip"
            @mouseleave="hideTooltip"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="$t('Toggle lecture list')"
            v-if="show('sidebarToggle')"
          >
            <i class="fas fa-list"></i>
          </a>
          <OffcanvasLectureList></OffcanvasLectureList>
        </div>
        <div class="col d-flex">
          <div class="d-none d-lg-block">
            <router-link
              v-if="previous"
              class="nav-link py-0 text-muted"
              :to="{
                name: 'lecture',
                params: { course: $route.params.course, lecture: previous.id },
              }"
            >
              <i class="fas fa-backward"></i>
            </router-link>
          </div>

          <div class="d-flex mx-auto" v-if="lecture && isAuthenticated">
            <a
              href="#"
              class="nav-link py-0 text-muted d-none d-md-block mx-2"
              @click.prevent="setUtilityTab('notes')"
              @mouseover="showTooltip"
              @mouseleave="hideTooltip"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              :title="$t('Notes')"
            >
              <i class="far fa-sticky-note"></i>
            </a>
            <Star :lecture="lecture" class="mx-2"></Star>
            <AutoplayAudio class="nav-link py-0 text-muted mx-2"></AutoplayAudio>
            <Autoplay class="nav-link py-0 text-muted mx-2"></Autoplay>
          </div>
          <div class="mx-auto" v-else></div>
          <div class="me-4 small" v-if="isAuthenticated">
            <button class="btn btn-lg-sm py-0" data-bs-toggle="modal" data-bs-target="#reviewModal">
              <i class="far fa-comment-dots d-lg-none text-muted"></i>
              <span class="d-none d-lg-inline">{{ 'Leave a review' | translate }}</span>
            </button>
          </div>
          <div class="" v-if="show('CompleteAndContinue')">
            <CompleteAndContinue class="nav-link py-0"></CompleteAndContinue>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import AutoplayAudio from './AutoplayAudio'
import Autoplay from './Autoplay'
import Star from './Star'
import CompleteAndContinue from './CompleteAndContinue'
import OffcanvasLectureList from './OffcanvasLectureList'

import _ from 'lodash'

export default {
  components: {
    Autoplay,
    AutoplayAudio,
    Star,
    CompleteAndContinue,
    OffcanvasLectureList,
  },
  data() {
    return {
      backLoading: false,
    }
  },
  methods: {
    goBack() {
      this.backLoading = true
      window.location.href = this.back
    },
    show(element) {
      if (_.includes(['sidebarToggle', 'CompleteAndContinue'], element) && _.get(this.course, 'type') === 'live') {
        return false
      }

      return true
    },
    showTooltip(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).show()
    },
    hideTooltip(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).hide()
    },
    setUtilityTab(type) {
      this.$store.commit('toggleUtilityTab', type)
    },
    setSideBarLeft(type) {
      this.$store.commit('setSideBarLeft', type)
    },
  },
  computed: {
    back() {
      return this.$api.back(this.$route.params.course)
    },
    previous() {
      return this.lectures[this.current - 1]
    },
    next() {
      return this.lectures[this.current + 1]
    },
    current() {
      if (this.lecture) {
        return this.lectures.findIndex((lecture) => lecture.id === this.lecture.id)
      }
      return -1
    },
    course() {
      return this.$store.state.course
    },
    lectures() {
      let sections = _.get(this.course, 'sections')
      if (sections) {
        return _.flatten(sections.map((section) => section.lectures))
      }
      return []
    },
    lecture() {
      let sections = _.get(this.course, 'sections')
      if (sections) {
        let lectures = _.flatten(sections.map((section) => section.lectures))
        if (lectures) {
          return lectures.find((lecture) => {
            return lecture.id === parseInt(this.$route.params.lecture)
          })
        }
      }

      return {}
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
  },
}
</script>
